export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  mangaCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '青春校园',
    slug: 'school-life',
    description: '发生在校园里的青春故事，懵懂的恋爱、热血的友情、青涩的成长，带你重温那段最美好的时光。',
    mangaCount: 128,
  },
  {
    id: 'cat-2',
    name: '热血运动',
    slug: 'sports',
    description: '挥洒汗水、追逐梦想的运动漫画，泳池里的奋力拼搏，赛场上的激情对决，点燃你的热血！',
    mangaCount: 86,
  },
  {
    id: 'cat-3',
    name: '恋爱甜宠',
    slug: 'romance',
    description: '甜到发齁的恋爱故事，从相识到相知，每一个心动瞬间都让人忍不住嘴角上扬。',
    mangaCount: 145,
  },
  {
    id: 'cat-4',
    name: '日常搞笑',
    slug: 'comedy',
    description: '轻松搞笑的日常漫画，脑洞大开的情节、夸张的表情、诙谐的对白，承包你的笑点。',
    mangaCount: 97,
  },
  {
    id: 'cat-5',
    name: '奇幻冒险',
    slug: 'fantasy',
    description: '穿梭于异世界的奇幻旅程，魔法、怪兽、勇者传说，在想象力的海洋中尽情遨游。',
    mangaCount: 73,
  },
  {
    id: 'cat-6',
    name: '悬疑推理',
    slug: 'mystery',
    description: '扣人心弦的悬疑故事，层层递进的推理谜题，在每一个反转中感受智力的碰撞。',
    mangaCount: 54,
  },
  {
    id: 'cat-7',
    name: '古风仙侠',
    slug: 'xianxia',
    description: '穿越千年的仙侠传说，剑与道、情与义，水墨丹青般的画风中讲述动人的东方传奇。',
    mangaCount: 68,
  },
  {
    id: 'cat-8',
    name: '科幻未来',
    slug: 'sci-fi',
    description: '探索未来的无限可能，人工智能、星际旅行、末日生存，科技与人性的深度碰撞。',
    mangaCount: 42,
  },
];